const WORK_KEYWORDS = [
  'besprechung',
  'meeting',
  'termin',
  'arbeit',
  'büro',
  'buero',
  'projekt',
  'daily',
  'weekly',
  'kundentermin',
  'konferenz',
  'schicht',
  'standup',
  'stand-up',
  'sync',
  'call',
  'interview',
  'review',
  '1:1',
  '1-1',
  'workshop',
  'presentation',
  'deadline',
  'office',
  'client',
  'team',
  'board',
  'planning',
  'retro',
  'sprint',
  'all-hands',
  'conference',
]

export function inferWorkEvent(title: string): boolean {
  const lower = title.toLowerCase()
  return WORK_KEYWORDS.some((keyword) => lower.includes(keyword))
}
